(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (!root || root.getAttribute('data-ss-ready') === 'true') return;

    var stage = root.querySelector('[data-ss-stage]');
    var track = root.querySelector('[data-ss-track]');
    var slides = toArray(root.querySelectorAll('[data-ss-slide]'));
    var dotsWrap = root.querySelector('[data-ss-dots]');
    var prev = root.querySelector('[data-ss-prev]');
    var next = root.querySelector('[data-ss-next]');
    var status = root.querySelector('[data-ss-status]');
    if (!track || slides.length === 0) return;

    root.setAttribute('data-ss-ready', 'true');

    var delay = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var designMode = window.Shopify && window.Shopify.designMode;
    var autoplaySetting = root.getAttribute('data-autoplay') === 'true';
    var index = 0;
    var timer = null;
    var hovering = false;
    var hidden = document.hidden;
    var dots = [];
    var wheelLock = false;

    function maxIndex() {
      return Math.max(0, slides.length - 1);
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      if (slides.length <= 1) return;
      for (var i = 0; i < slides.length; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ss__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Show story image ' + (i + 1));
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        (function (page) {
          btn.addEventListener('click', function () {
            go(page);
          });
        })(i);
        dotsWrap.appendChild(btn);
        dots.push(btn);
      }
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (status) {
        status.textContent = (index + 1) + ' / ' + slides.length;
      }
      root.setAttribute('data-ss-at-start', index === 0 ? 'true' : 'false');
      root.setAttribute('data-ss-at-end', index >= maxIndex() ? 'true' : 'false');
    }

    function go(target) {
      index = Math.max(0, Math.min(target, maxIndex()));
      var slide = slides[index];
      if (slide) {
        track.scrollTo({
          top: slide.offsetTop,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
      updateDots();
      restartTimer();
    }

    function nextSlide(wrap) {
      if (index >= maxIndex()) {
        if (wrap) go(0);
        return false;
      }
      go(index + 1);
      return true;
    }

    function prevSlide(wrap) {
      if (index <= 0) {
        if (wrap) go(maxIndex());
        return false;
      }
      go(index - 1);
      return true;
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (!autoplaySetting || designMode || reduceMotion || hovering || hidden || maxIndex() === 0) return;
      timer = setInterval(function () {
        nextSlide(true);
      }, delay);
    }

    function restartTimer() {
      stopTimer();
      startTimer();
    }

    function passScrollToPage(deltaY) {
      window.scrollBy({ top: deltaY, left: 0, behavior: 'auto' });
    }

    function onWheel(event) {
      if (maxIndex() === 0) return;
      if (Math.abs(event.deltaY) < 4) return;

      var scrollingDown = event.deltaY > 0;
      var atStart = index <= 0 && !scrollingDown;
      var atEnd = index >= maxIndex() && scrollingDown;

      // First/last slide: release to page scroll so user never gets stuck
      if (atStart || atEnd) {
        event.preventDefault();
        passScrollToPage(event.deltaY);
        return;
      }

      event.preventDefault();
      if (wheelLock) return;
      wheelLock = true;

      if (scrollingDown) nextSlide(false);
      else prevSlide(false);

      window.setTimeout(function () {
        wheelLock = false;
      }, reduceMotion ? 120 : 480);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        prevSlide(false);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        nextSlide(false);
      });
    }

    root.addEventListener('mouseenter', function () {
      hovering = true;
      stopTimer();
    });
    root.addEventListener('mouseleave', function () {
      hovering = false;
      startTimer();
    });

    document.addEventListener('visibilitychange', function () {
      hidden = document.hidden;
      if (hidden) stopTimer();
      else startTimer();
    });

    window.addEventListener('resize', function () {
      go(index);
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        var nearest = 0;
        var nearestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetTop - track.scrollTop);
          if (dist < nearestDist) {
            nearestDist = dist;
            nearest = i;
          }
        });
        if (nearest !== index) {
          index = nearest;
          updateDots();
        }
      });
    }, { passive: true });

    var wheelTarget = stage || track;
    wheelTarget.addEventListener('wheel', onWheel, { passive: false });

    buildDots();
    updateDots();
    startTimer();
  }

  function boot() {
    toArray(document.querySelectorAll('[data-ss]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-ss]')).forEach(function (el) {
      el.removeAttribute('data-ss-ready');
      init(el);
    });
  });
})();
